import { Modal } from 'antd';
import type { ProductImportResult } from '@/types/product';
import styles from './ProductImportResultModal.module.scss';

interface ProductImportResultModalProps {
  open: boolean;
  result: ProductImportResult | null;
  message?: string | null;
  onClose: () => void;
}

export function ProductImportResultModal({
  open,
  result,
  message,
  onClose,
}: ProductImportResultModalProps) {
  if (!result) return null;

  return (
    <Modal
      title="Import finished"
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Close"
      cancelButtonProps={{ style: { display: 'none' } }}
      width={560}
    >
      {message ? <p className={styles.summary}>{message}</p> : null}

      <div className={styles.stats}>
        <div>
          <strong>{result.created}</strong>
          <span>Created</span>
        </div>
        <div>
          <strong>{result.updated}</strong>
          <span>Updated</span>
        </div>
        <div>
          <strong>{result.failed}</strong>
          <span>Failed</span>
        </div>
      </div>

      {result.errors.length ? (
        <div className={styles.errors}>
          <p className={styles.errorsTitle}>Errors</p>
          <ul>
            {result.errors.map((error) => (
              <li key={error}>{error}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </Modal>
  );
}
